import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveAnalysisSort, setActiveAnalysisSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopStrideAnalysis = ({ location, currentQuery, setCurrentQuery, types, getSortParams, isHome, isPhysio, setLoadingProducts }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-analysis button"
  );

    useEffect(() => {
          
        filterButtons.forEach(item => {
            item.classList.remove("active");
        });

        if (query && query.analysis) {
            let analysis = query.analysis.split('_');
            analysis.map(size => {
                var element = document.getElementById("type_"+size);
                if (element){
                    element.classList.add("active")
                }
            })
        }

        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

    function constructAddQueryPath(query, size) {
        if (query && query.types) {
            return query.types + "_" + size
        }
        return size
    }

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{
                    isHome && isPhysio ? "Pour quel type d'utilisation ?" : 
                    isHome && currentQuery.genders == "Women" ? "Quel type de foulée a-t-elle ?" : 
                        isHome ? "Quel type de foulée a-t-il ?" : isPhysio ? "Type d'utilisation :" : "Type de foulée :"} &nbsp;</h4>
                     <div className="sidebar-widget-tag-analysis mt-10" style={{display: 'block'}}>
                        {types ? (
                            <ul>
                                {types.map((type, key) => {
                                    return (
                                        <li key={"type_"+key}>
                                            <button
                                                className="toto"
                                                id={"type_"+type}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("type", "");
                                                        setCurrentQuery({ ...currentQuery, analysis: ""});
                                                        deleteActiveAnalysisSort(e);
                                                    } else {
                                                        getSortParams("type", type);
                                                        setCurrentQuery({ ...currentQuery, analysis: type});
                                                        setActiveAnalysisSort(e);
                                                    }
                                                }}
                                            >
                                                {t(type.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{
                        isHome && isPhysio ? "Pour quel type d'utilisation ?" : 
                        isHome && currentQuery.genders == "Women" ? "Quel type de foulée a-t-elle ?" : 
                        isHome ? "Quel type de foulée a-t-il ?" : isPhysio ? "Type d'utilisation :" : "Type de foulée :"} &nbsp;</h4>
                    <div className="sidebar-widget-tag-analysis mt-10">
                        {types ? (
                            <ul>
                                {types.map((type, key) => {
                                    return (
                                        <li key={"type_"+key}>
                                            <button
                                                className="toto"
                                                id={"type_"+type}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("type", "");
                                                        setCurrentQuery({ ...currentQuery, analysis: ""});
                                                        deleteActiveAnalysisSort(e);
                                                    } else {
                                                        getSortParams("type", type);
                                                        setCurrentQuery({ ...currentQuery, analysis: type});
                                                        setActiveAnalysisSort(e);
                                                    }
                                                }}
                                            >
                                                {t(type.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function getLabel(type, t){
    switch (type){
        case "Women":
            return t('type')
        case "Men":
            return "Homme"
        case "Unisex":
            return "Non Genré"
        default:
            return
    }
}

export function ConstructRemoveTypeQueryPath(query, sizeToRemove) {
    if (query && query.types) {
        let types = query.types.split('_');
        types = types.filter(size => {
            return size !== sizeToRemove;
        })
        if (types.length > 0) {
            let newSizeQuery = ""
            types.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopStrideAnalysis.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopStrideAnalysis;
